<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h3 class="text-text-neutral-primary text-base font-medium">
            {{ t('main.multiTrip.info.title') }}
          </h3>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div class="space-y-4 px-4 pb-4">
        <section
          class="bg-background-neutral-secondary space-y-4 rounded-2xl p-4"
        >
          <p class="text-text-neutral-primary text-base">
            {{ t('main.multiTrip.info.subtitle') }}
          </p>
          <ul class="space-y-4">
            <li
              v-for="(item, idx) in infoItems"
              :key="idx"
              class="flex items-start gap-2"
            >
              <img :src="item.icon" class="shrink-0" />
              <div class="space-y-1">
                <h4 class="text-text-neutral-primary text-base font-semibold">
                  {{ item.title }}
                </h4>
                <p class="text-text-neutral-primary text-base">
                  {{ item.description }}
                </p>
              </div>
            </li>
          </ul>
        </section>
        <FreeButton type="button" class="gray-button w-full" @click="hide">
          {{ t('main.multiTrip.info.gotIt') }}
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
    FreeButton,
  } from 'freedom-shared';

  import SavingsIcon from '@/assets/images/multi-trip/savings-icon-24x24.svg?url';
  import GlobeIcon from '@/assets/images/multi-trip/globe-icon-24x24.svg?url';
  import HeartIcon from '@/assets/images/multi-trip/heart-icon-24x24.svg?url';

  defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const infoItems = [
    {
      title: t('main.multiTrip.info.savings.title'),
      description: t('main.multiTrip.info.savings.description'),
      icon: SavingsIcon,
    },
    {
      title: t('main.multiTrip.info.emotions.title'),
      description: t('main.multiTrip.info.emotions.description'),
      icon: GlobeIcon,
    },
    {
      title: t('main.multiTrip.info.convenience.title'),
      description: t('main.multiTrip.info.convenience.description'),
      icon: HeartIcon,
    },
  ];
</script>
